export default __webpack_public_path__ + "static/char-v-62-070033d0d693595a59b3d8fdacd592e8.webp";